// ========== Global Variables ==========
let canvas, ctx;
let carLogoImage = null; // global image object
let resizeTimeout = null;
// Default options
let carLogoUrl = "https://cdn.shopify.com/s/files/1/0865/2881/9519/files/custom-neon-sign-Mercedes-Benz.png?v=1758273796";
let carLogoName = "Mercedes-Benz";
let logoColor = "#FFFFFF";
let logoColorName = "White";
let customText = "";
let fontFamily = "Alexa";
// RGB
let isRgbMode = false;
let rgbAnimationId = null;
let rgbColors = ["#FFFFFF", "#FFF59D", "#FFB559", "#679AFF", "#FF5353", "#68FF6B", "#E488FD", "#FF8FC9", "#6FE6DA"];
let currentRgbIndex = 0;

// ========== Initialize ==========
document.addEventListener("DOMContentLoaded", () => {
    setupEventListeners();
    cancelSticky();
    carLogoSwitch();
});

// Load car logo and setup canvas after all resources are loaded
window.addEventListener("load", () => {
    setupCanvas();
    setDefaultOptions();
    loadCarLogo();
});

/**
 * When scroll to product-form__buy-buttons, customizeView will move to top
 */
function cancelSticky() {
    const customizeView = document.getElementById("customizeView");
    const trigger = document.querySelector(".product-form__buy-buttons");
    if (!customizeView || !trigger) return;

    let resizeTimeout;

    // Check scroll position and update class
    function checkSticky() {
        const triggerRect = trigger.getBoundingClientRect();
        const customizeRect = customizeView.getBoundingClientRect();

        if (triggerRect.top < customizeRect.height + 24) {
            customizeView.classList.add("smooth-unstick");
        } else {
            customizeView.classList.remove("smooth-unstick");
        }
    }

    // Enable sticky behavior
    function enableSticky() {
        checkSticky();
        window.addEventListener("scroll", checkSticky);
    }

    // Disable sticky behavior
    function disableSticky() {
        window.removeEventListener("scroll", checkSticky);
        customizeView.classList.remove("smooth-unstick");
    }

    // Initialize based on current width
    if (window.innerWidth <= 1000) {
        enableSticky();
    } else {
        disableSticky();
    }

    // Listen for window resize with debounce
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            if (window.innerWidth <= 1000) {
                enableSticky();
            } else {
                disableSticky();
            }
        }, 100); // 100ms debounce
    });
}

/**
 * Initialize canvas element and setup resize listener
 */
function setupCanvas() {
    canvas = document.getElementById("textCanvas");
    ctx = canvas.getContext("2d");

    // Listen for window resize with debounce
    window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(resizeCanvas, 100); // 100ms debounce
    });

    resizeCanvas();
}

/**
 * Resize canvas to fit container and handle high DPI displays
 */
function resizeCanvas() {
    if (!canvas || !ctx) return;

    const container = canvas.parentElement;
    if (!container) return;

    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight || containerWidth;

    if (containerWidth <= 0 || containerHeight <= 0) return;

    const dpr = window.devicePixelRatio || 1;

    // Reset transform before resizing
    ctx.setTransform(1, 0, 0, 1, 0, 0);

    // Set canvas actual size
    canvas.width = containerWidth * dpr;
    canvas.height = containerHeight * dpr;

    // Set CSS size
    canvas.style.width = containerWidth + "px";
    canvas.style.height = containerHeight + "px";

    // Scale for high DPI
    ctx.scale(dpr, dpr);

    // Redraw
    if (carLogoImage && carLogoImage.complete) {
        updateCanvasContent();
    }
}

/**
 * Setup all event listeners for the customize interface
 */
function setupEventListeners() {
    // background-choose-group
    const backgroundChooseList = document.querySelector(".customize-canvas-background-list");
    if (backgroundChooseList) {
        backgroundChooseList.querySelectorAll(".customize-canvas-background-img").forEach((selector) => {
            selector.addEventListener("click", changeBackground);
        });
    }

    // car logo choose
    const carLogoChooseList = document.querySelector(".car-logo-page-track");
    if (carLogoChooseList) {
        carLogoChooseList.querySelectorAll(".car-logo-selector").forEach((selector) => {
            selector.addEventListener("click", changeCarLogo);
        });
    }

    // color-choose-group
    const colorChooseGroup = document.querySelector(".color-choose-group");
    if (colorChooseGroup) {
        colorChooseGroup.querySelectorAll(".color-selector").forEach((selector) => {
            selector.addEventListener("click", chooseColor);
        });
    }

    // customText input listener
    const textarea = document.getElementById("customTextTextarea");
    if (textarea) {
        textarea.addEventListener("input", textareaInput);
    }

    // font-choose-group
    const fontChooseGroup = document.querySelector(".font-choose-group");
    if (fontChooseGroup) {
        fontChooseGroup.querySelectorAll(".font-selector").forEach((selector) => {
            selector.addEventListener("click", chooseFont);
        });
    }

    // font-choose-header (toggle dropdown)
    const fontChooseHeader = document.querySelector(".font-choose-header");
    if (fontChooseHeader) {
        fontChooseHeader.addEventListener("click", toggleFontOptions);
    }
}

/**
 * Load car logo image globally
 */
function loadCarLogo() {
    if (!carLogoUrl) return;
    carLogoImage = new Image();
    carLogoImage.src = carLogoUrl;
    carLogoImage.onload = () => {
        updateCanvasContent();
    };
}

/**
 * Start RGB color animation
 */
function startRgbAnimation() {
    if (rgbAnimationId) return; // Already running

    function animate() {
        if (!isRgbMode) return; // Stop if not in RGB mode

        logoColor = rgbColors[currentRgbIndex];
        currentRgbIndex = (currentRgbIndex + 1) % rgbColors.length;

        updateCanvasContent();

        rgbAnimationId = setTimeout(animate, 1000); // Change color every x ms
    }

    animate();
}

/**
 * Stop RGB color animation
 */
function stopRgbAnimation() {
    if (rgbAnimationId) {
        clearTimeout(rgbAnimationId);
        rgbAnimationId = null;
    }
    isRgbMode = false;
}

/**
 * Handle user selecting a new car logo
 */
function changeCarLogo(event) {
    const selectedCarLogo = event.currentTarget;
    const logoImg = selectedCarLogo.querySelector(".car-logo-img");
    if (!logoImg) return;

    // Update global car logo URL and name
    carLogoUrl = logoImg.dataset.url;
    carLogoName = logoImg.dataset.name;

    // Update hidden input for form submission
    const productInfoContainer = document.querySelector(".product__info") || document;
    const carLogoInput = productInfoContainer.querySelector("#carLogoInput");
    if (carLogoInput) carLogoInput.value = carLogoName;

    // Update UI selection state
    const logoElements = document.getElementsByClassName("car-logo-selector");
    for (let el of logoElements) el.classList.remove("selected");
    selectedCarLogo.classList.add("selected");

    // Create a new Image object to load the new car logo
    carLogoImage = new Image();
    carLogoImage.onload = () => {
        // Draw the canvas after the image is fully loaded
        updateCanvasContent();
    };
    carLogoImage.src = carLogoUrl; // Trigger image loading
}

/**
 * Textarea input event
 */
function textareaInput(event) {
    const textarea = event.target;
    const value = textarea.value;
    customText = value;
    updateCanvasContent();
}

/**
 * Change canvas background when background option is clicked
 */
function changeBackground(event) {
    const clickedElement = event.target;
    const customizeView = document.getElementById("customizeView");

    // Remove selected class from all background items
    const allBackgroundItems = document.querySelectorAll(".customize-canvas-background-item");
    allBackgroundItems.forEach((item) => item.classList.remove("selected"));

    // Add selected class to clicked item's parent
    clickedElement.parentElement.classList.add("selected");

    // Change background based on element type
    if (clickedElement.tagName === "IMG" && clickedElement.src) {
        // For image elements with src
        customizeView.style.backgroundImage = "url(" + clickedElement.src + ")";
        customizeView.style.backgroundColor = "";
        customizeView.style.backgroundSize = "cover";
        customizeView.style.backgroundPosition = "center";
        customizeView.style.backgroundRepeat = "no-repeat";
    } else if (clickedElement.tagName === "DIV" && clickedElement.style.backgroundColor) {
        // For div elements with background color
        customizeView.style.backgroundColor = clickedElement.style.backgroundColor;
        customizeView.style.backgroundImage = "";
    }
}

/**
 * Handle car logo pagination and navigation
 */
function carLogoSwitch() {
    const track = document.querySelector(".car-logo-page-track");
    const prevButtons = document.querySelectorAll(".car-logo-prev-button");
    const nextButtons = document.querySelectorAll(".car-logo-next-button");

    let page = 0;
    const totalPages = document.querySelectorAll(".car-logo-page-track > div").length;

    function update() {
        const pageWidth = document.querySelector(".car-logo-container").offsetWidth;
        track.style.transform = `translateX(-${page * pageWidth}px)`;

        prevButtons.forEach((btn) => (btn.disabled = page === 0));
        nextButtons.forEach((btn) => (btn.disabled = page === totalPages - 1));
    }

    prevButtons.forEach((button) => {
        button.addEventListener("click", () => {
            if (page > 0) page--;
            update();
        });
    });

    nextButtons.forEach((button) => {
        button.addEventListener("click", () => {
            if (page < totalPages - 1) page++;
            update();
        });
    });

    update();
}

/**
 * Toggle font options dropdown visibility
 */
function toggleFontOptions() {
    const fontGroup = document.getElementById("fontOptionsGroup");
    const arrow = document.querySelector(".font-dropdown-arrow");

    if (fontGroup.classList.contains("show")) {
        fontGroup.classList.remove("show");
        arrow.classList.remove("rotated");
    } else {
        fontGroup.classList.add("show");
        arrow.classList.add("rotated");
    }
}

/**
 * Select a font and update UI accordingly
 * @param {Event} event - Click event
 */
function chooseFont(event) {
    const selectedElement = event.target;
    const font = selectedElement.dataset.font;

    document.getElementById("textFontInput").value = font;
    fontFamily = font;

    // Update selected font display
    document.getElementById("selectedFontDisplay").textContent = font;
    document.getElementById("selectedFontDisplay").style.fontFamily = font;

    // Update font selector styles - remove selected from all
    const fontElements = document.getElementsByClassName("font-selector");
    for (let el of fontElements) {
        el.classList.remove("selected");
    }

    // Add selected to clicked element
    selectedElement.classList.add("selected");

    updateCanvasContent();
}

/**
 * Select a color and update UI accordingly
 * @param {Event} event - Click event
 */
function chooseColor(event) {
    const selectedElement = event.target;

    // Update logoColorName and input value
    logoColorName = selectedElement.dataset.name;
    document.getElementById("logoColorInput").value = logoColorName;

    // Remove selected class from all color elements
    const colorElements = document.getElementsByClassName("color-selector");
    for (let el of colorElements) {
        el.classList.remove("selected");
    }
    // Add selected class to span element
    selectedElement.classList.add("selected");

    // Check if RGB mode is selected
    if (logoColorName === "RGB") {
        isRgbMode = true;
        startRgbAnimation();
    } else {
        // Stop RGB animation and use static color
        stopRgbAnimation();
        logoColor = selectedElement.style.background;
        updateCanvasContent();
    }
}

/**
 * Set default options on initialization
 */
function setDefaultOptions() {
    // Get the product info container
    const productInfoContainer = document.querySelector(".product__info") || document;

    // Set form properties for submission
    // car logo
    productInfoContainer.querySelector("#carLogoInput").value = carLogoName;
    // car logo color
    productInfoContainer.querySelector("#logoColorInput").value = logoColorName;
    // customText
    productInfoContainer.querySelector("#customTextTextarea").value = customText;
    // font
    productInfoContainer.querySelector("#textFontInput").value = fontFamily;

    // Set default car logo
    const carLogoElements = productInfoContainer.querySelectorAll(".car-logo-selector");
    for (let el of carLogoElements) {
        el.classList.remove("selected");
    }
    const selectedCarLogoSpan = productInfoContainer.querySelector(`.car-logo-img[data-name="${carLogoName}"]`);
    if (selectedCarLogoSpan) {
        selectedCarLogoSpan.parentElement.classList.add("selected");
        // Set car logo info
        carLogoUrl = selectedCarLogoSpan.dataset.url;
        carLogoName = selectedCarLogoSpan.dataset.name;
    }

    // Set and display default font
    productInfoContainer.querySelector("#selectedFontDisplay").textContent = fontFamily;
    productInfoContainer.querySelector("#selectedFontDisplay").style.fontFamily = fontFamily;

    // Set default font selector
    const fontElements = productInfoContainer.querySelectorAll(".font-selector");
    for (let el of fontElements) {
        el.classList.remove("selected");
    }
    const selectedFont = productInfoContainer.querySelector(`.font-selector[data-font="${fontFamily}"]`);
    if (selectedFont) {
        selectedFont.classList.add("selected");
    }

    // Set default color
    const colorElements = productInfoContainer.querySelectorAll(".color-selector");
    for (let el of colorElements) {
        el.classList.remove("selected");
    }
    const selectedColor = productInfoContainer.querySelector(`.color-selector[data-name="${logoColorName}"]`);
    if (selectedColor) {
        selectedColor.classList.add("selected");
        logoColor = selectedColor.style.background;
    }

    // Set default background
    const backgroundChooseList = document.querySelector(".customize-canvas-background-list");
    if (backgroundChooseList) {
        const backgroundImages = backgroundChooseList.querySelectorAll(".customize-canvas-background-img");
        if (backgroundImages.length > 0) {
            customizeView.style.backgroundImage = "url(" + backgroundImages[0].src + ")";
            customizeView.style.backgroundColor = "";
            customizeView.style.backgroundSize = "cover";
            customizeView.style.backgroundPosition = "center";
            customizeView.style.backgroundRepeat = "no-repeat";
        }
    }

    updateCanvasContent();
}

/**
 * Update canvas content by drawing car logo and text with neon-like glow
 */
function updateCanvasContent() {
    if (!canvas || !ctx) return;

    const logicalWidth = parseInt(canvas.style.width);
    const logicalHeight = parseInt(canvas.style.height);

    const dpr = window.devicePixelRatio || 1;
    canvas.width = logicalWidth * dpr;
    canvas.height = logicalHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (carLogoImage && carLogoImage.complete) {
        const img = carLogoImage;
        const imgAspectRatio = img.width / img.height;
        let imgWidth = logicalWidth * 0.4;
        let imgHeight = imgWidth / imgAspectRatio;
        if (imgHeight > logicalHeight * 0.4) {
            imgHeight = logicalHeight * 0.4;
            imgWidth = imgHeight * imgAspectRatio;
        }

        const imgX = (logicalWidth - imgWidth) / 2;
        const imgY = logicalHeight * 0.2;

        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";

        // Inner glow
        const innerGlow = [
            { color: "#ffffff", blur: 3, opacity: 0.3 },
            { color: logoColor, blur: 6, opacity: 0.3 },
        ];
        for (const layer of innerGlow) {
            ctx.save();
            ctx.globalCompositeOperation = "lighter";
            ctx.shadowColor = layer.color;
            ctx.shadowBlur = layer.blur;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            ctx.globalAlpha = layer.opacity;
            ctx.drawImage(img, imgX, imgY, imgWidth, imgHeight);
            ctx.restore();
        }

        // Final logo color
        ctx.save();
        ctx.drawImage(img, imgX, imgY, imgWidth, imgHeight);
        ctx.globalCompositeOperation = "source-atop";
        ctx.fillStyle = logoColor;
        ctx.fillRect(imgX, imgY, imgWidth, imgHeight);
        ctx.restore();

        // Outer glow
        const outerGlow = [
            { color: logoColor, blur: 15, opacity: 0.12 },
            { color: logoColor, blur: 30, opacity: 0.08 },
            { color: logoColor, blur: 50, opacity: 0.05 },
        ];
        for (const layer of outerGlow) {
            ctx.save();
            ctx.globalCompositeOperation = "lighter";
            ctx.shadowColor = layer.color;
            ctx.shadowBlur = layer.blur;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            ctx.globalAlpha = layer.opacity;
            ctx.drawImage(img, imgX, imgY, imgWidth, imgHeight);
            ctx.restore();
        }

        // Extra highlight
        ctx.save();
        ctx.globalCompositeOperation = "lighter";
        ctx.drawImage(img, imgX, imgY, imgWidth, imgHeight);
        ctx.restore();
    }

    drawCustomText(logicalWidth, logicalHeight, carLogoImage ? logicalHeight * 0.2 + logicalHeight * 0.4 : undefined);
}

/**
 * Draw custom text with proper positioning
 * @param {number} logicalWidth - Canvas width in CSS pixels
 * @param {number} logicalHeight - Canvas height in CSS pixels
 * @param {number} [startY] - Starting Y position for text (optional)
 */
function drawCustomText(logicalWidth, logicalHeight, startY) {
    ctx.fillStyle = "#ffffff";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    // Calculate font size and position
    let fontSize = Math.min(logicalWidth, logicalHeight) * 0.15;
    const padding = 20;
    const maxWidth = logicalWidth - padding * 2;

    while (fontSize > 10) {
        ctx.font = `${fontSize}px ${fontFamily}`;
        if (ctx.measureText(customText).width <= maxWidth) break;
        fontSize--;
    }

    const centerX = logicalWidth / 2;
    const centerY = startY ? startY + fontSize : logicalHeight / 2;

    if (ctx.measureText(customText).width > maxWidth) {
        const scaleRatio = maxWidth / ctx.measureText(customText).width;
        ctx.save();
        ctx.translate(centerX, centerY);
        ctx.scale(scaleRatio, scaleRatio);
        drawTextWithShadows(ctx, customText, 0, 0, logoColor);
        ctx.restore();
    } else {
        drawTextWithShadows(ctx, customText, centerX, centerY, logoColor);
    }
}

/**
 * Draw customText with multiple shadow layers for neon effect
 * @param {CanvasRenderingContext2D} ctx - Canvas rendering context
 * @param {string} customText - Text to draw
 * @param {number} x - X coordinate
 * @param {number} y - Y coordinate
 * @param {string} color - Text color
 */
function drawTextWithShadows(ctx, customText, x, y, color) {
    const shadows = [
        { color: "#ffffff", blur: 5 },
        { color: "#ffffff", blur: 10 },
        { color: color, blur: 20 },
        { color: color, blur: 30 },
        { color: color, blur: 40 },
        { color: color, blur: 55 },
        { color: color, blur: 75 },
    ];

    for (let shadow of shadows) {
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur;
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.fillText(customText, x, y);
    }

    ctx.shadowColor = "transparent";
    ctx.fillText(customText, x, y);
}
